import React from "react";
import { Toast } from "antd-mobile";
import { post } from "../../utils/request";
import QRCode from "qrcode";

import api from "../index/api";
import logo from "./logo.png";
import downImg from './images/download.png'
import "./index.less";
class yysChargingOperatorQr extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps: {},

            detailData: {},
            qrImg: "",
            canInvite: true
        };
    }

    // #/yysChargingOperatorQr?app_stoken=xxxx
    componentDidMount() {
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }

            if (
                ops.app_stoken === "null" ||
                ops.app_stoken === "(null)" ||
                ops.app_stoken === "undefined" ||
                !ops.app_stoken
            ) {
                Toast.fail("请登录APP再进行操作", 999);
                return;
            }
            this.setState(
                {
                    urlOps: ops,
                },
                () => {
                    this.getDetail();
                }
            );
        }
    }

    viewPort = () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf("micromessenger") > -1,
            isQQ: u.indexOf("qq/") > -1,
            trident: u.indexOf("trident") > -1, //IE内核
            presto: u.indexOf("presto") > -1, //opera内核
            webKit: u.indexOf("applewebkit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("gecko") > -1 && u.indexOf("khtml") == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) || !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("ipad") > -1, //是否iPad
            webApp: u.indexOf("safari") == -1, //是否web应该程序，没有头部与底部
        };
    };

    // 获取二维码中转链接
    getQrLinkUrl = (detailData = {}) => {
        const originUrl = `${window.location.origin}/payment/#/yysChargingOperatorShare?inviteCode=${detailData.partyId}&name=${detailData.customerName}`;
        return `https://hellogil.com/payment/#/transferQr?type=H5&QRCode=${encodeURIComponent(originUrl)}`;
    };

    // 生成二维码
    generateQrCode = (detailData = {}) => {
        QRCode.toDataURL(
            this.getQrLinkUrl(detailData),
            {
                errorCorrectionLevel: "H",
                type: "image/jpeg",
                quality: 0.3,
                margin: 1,
            },
            (err, url) => {
                if (err) throw err;
                this.setState({
                    qrImg: url,
                });
            }
        );
    };

    // 获取邀请二维码详情
    getDetail() {
        const { urlOps } = this.state;
        post({
            url:
                api.getInviteQrCodeDetail +
                "?app_stoken=" +
                urlOps.app_stoken,
            data: {},
        }).then(
            (res) => {
                if (res.result === "success") {
                    const { carrierCustomerName, invitePartyId } = res.data || {};
                    const detailData = {
                        customerName: carrierCustomerName,
                        partyId: invitePartyId,
                    };
                    this.setState({
                        canInvite: res.data.isCanInvite === 1,
                        detailData,
                    });
                    this.generateQrCode(detailData);
                } else {
                    this.setState({
                        canInvite: false,
                    });
                    Toast.info(res.msg, 1);
                    this.generateQrCode({});
                }
            },
            (res) => {
                Toast.info("获取邀请二维码详情失败", 1);
                this.setState({
                    canInvite: false,
                });
                this.generateQrCode({});
            }
        );
    }

    render() {
        const { qrImg, detailData, canInvite } = this.state;
        return (
            <div className="yysChargingOperatorQrBox">
                <div className="title">{detailData.customerName}</div>
                <div className="qrBox">
                    <div className="qrTitle">·聚运力&nbsp;&nbsp; ·降成本&nbsp;&nbsp; ·创收益</div>
                    <div className="qr">
                        <div className="qr-img-wrapper">
                            {qrImg ? <img src={qrImg} /> : ""}
                            {!canInvite && (
                                <div className="qr-mask">
                                    <span>您无邀请权限，请联系充电合伙人</span>
                                </div>
                            )}
                        </div>
                        <div>打开微信扫一扫</div>
                    </div>
                    <div className="logo">
                        <img src={logo} />
                    </div>
                </div>
                {canInvite && (
                <div
                    className="qrBtn"
                    onClick={() => {
                        let viewPort = this.viewPort();
                        const ops = {
                            url: this.getQrLinkUrl(detailData),
                        };
                        if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
                            if (window.webkit) {
                                window.webkit.messageHandlers.downloadQrCode.postMessage(
                                    ops
                                );
                            }
                        } else {
                            if (window.huilian) {
                                window.huilian.downloadQrCode(ops.url);
                            }
                        }
                    }}
                >
                    <img className="downImg" src={downImg} />
                    保存二维码
                </div>
                )}
            </div>
        );
    }
}

export default yysChargingOperatorQr;



// WEBPACK FOOTER //
// ./src/yysChargingOperator/qr/index.js